module.exports = __webpack_public_path__ + "img/sixpackcarrier13.59a8cfe5.jpg";